import { createContext } from "react";
import * as data from "./data";

export const DataContext = createContext({
  UIGraphics: data.uiGraphics,
  Fonts: data.fonts,
  Colors: data.colors,
  Icons: data.icons,
  Logos: data.logos,
  Favicons: data.favicons,
  IconFonts: data.iconFonts,
  StockPhotos: data.stockPhotos,
  StockVideos: data.stockVideos,
  StockMusic: data.stockMusic,
  Vectors: data.vectors,
  DesignInspiration: data.designInspiration,
  ProductMockups: data.productMockups,
  Templates: data.templates,
  CSSFrameworks: data.cssFrameworks,
  CSSMethodologies: data.cssMethodologies,
  CSSAnimations: data.cssAnimations,
  JSAnimationLibraries: data.jsAnimationLibraries,
  JSChartLibraries: data.jsChartLibraries,
  UIKits: data.uiKits,
  ReactUILibraries: data.reactLibraries,
  VueUILibraries: data.vueLibraries,
  AngularUILibraries: data.angularLibraries,
  SvelteUILibraries: data.svelteLibraries,
  ReactNativeUILibraries: data.reactNativeLibraries,
  DesignSystems: data.designSystems,
  DesignTools: data.designTools,
  DesignSoftware: data.designSoftware,
  ImageCompression: data.imageCompression,
  ChromeExtensions: data.chromeExtensions,
  Others: data.others,
});
